import { render } from "./milestone-details.vue?vue&type=template&id=a990c3f0&scoped=true&ts=true"
import script from "./milestone-details.vue?vue&type=script&lang=ts"
export * from "./milestone-details.vue?vue&type=script&lang=ts"

import "./milestone-details.vue?vue&type=style&index=0&id=a990c3f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a990c3f0"]])

export default __exports__